// extracted by mini-css-extract-plugin
module.exports = {"SectionsMap":"styles_SectionsMap__mwxDZ","section":"styles_section__kFrYq","active":"styles_active__b9KBf","sectionButton":"styles_sectionButton__S1p65"};